'use client'

import { GalleryBlock as GalleryBlockTypes } from '@/payload-types'
import { cn } from '@/utilities/ui'
import { Media } from '../components/Media/Media'
import React from 'react'

const GalleryBlock: React.FC<GalleryBlockTypes> = (props) => {
  const { images } = props

  return (
    <>
      <div
        className={cn('px-6 lg:px-16 py-6 lg:mb-10 flex flex-col md:flex-row items-center w-full')}
      >
        {images &&
          images.map(
            (media) =>
              media &&
              typeof media === 'object' && (
                <div key={media.id}>
                  <Media
                    className="py-2 md:py-0 px-2 lg:px-4"
                    imgClassName="aspect-5/4 w-3xl object-cover rounded-[0.8rem] mx-auto"
                    priority
                    resource={media.image}
                  />
                </div>
              ),
          )}
      </div>
    </>
  )
}

export { GalleryBlock }
